import PromotionsCounter from 'src/common/PromotionsCounter/PromotionsCounter';

export const MENU_ITEMS_WITH_COUNTER = ['/promotions'];

export const MENU_ITEM_COUNTER_COMPONENT = {
  '/promotions': PromotionsCounter,
};
